import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, IDeleteRequest } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { DeleteRequestService } from "src/app/providers/deleteRequest.service";

export class DeleteRequestDataSource extends MatTableDataSourceBackendExtended<IDeleteRequest> {
  constructor(private deleteRequestService: DeleteRequestService) {
    super();
  }

  public data(params: IDataSourceBackendParam): Observable<IDeleteRequest[]> {
    return this.deleteRequestService.list(params);
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
    Use this, the day we decide to make the page implements AbstractBackendTablePage
    return this.deleteRequestService
      .getDeleteRequestCount(param.services, param.search, param.filters).pipe(map((response) => response.count));
    */
    return of(0);
  }
}
